import React from "react";
import UseContext from "hooks/useContext";
import SectionWrapper from "pages/createMission/components/SectionWrapper";
import SummaryField from "components/summaryField/SummaryField";
import {
    SUMMARY_ROWS,
    buildSummaryFromWizardData,
    getSummaryRowLabel,
    getSummaryRowValue,
} from "pages/missionTemplates/components/MissionTemplateSummary";
import {
    TEMPLATE_STEP,
    getTemplateStepPage,
} from "pages/missionTemplates/templateSteps";
import { useRiskyPositions } from "pages/missionTemplates/utils/templateRiskyPositions";

/** Which step owns each line of the summary, so its pencil leads back there. */
const STEP_BY_FIELD = {
    name: TEMPLATE_STEP.ACTIVITY,
    activity: TEMPLATE_STEP.ACTIVITY,
    qualification: TEMPLATE_STEP.ACTIVITY,
    riskyPosition: TEMPLATE_STEP.RISKY_POSITION,
    tools: TEMPLATE_STEP.PREREQUIS,
    licences: TEMPLATE_STEP.PREREQUIS,
    languages: TEMPLATE_STEP.PREREQUIS,
    dressCode: TEMPLATE_STEP.PREREQUIS,
    tasks: TEMPLATE_STEP.TASKS,
    address: TEMPLATE_STEP.LOCATION_SALARY,
    salary: TEMPLATE_STEP.LOCATION_SALARY,
    contact: TEMPLATE_STEP.LOCATION_SALARY,
};

const ConfirmationTemplate = () => {
    const { templateData, setTemplatePage, language } = UseContext();
    const { riskyPositions } = useRiskyPositions();
    const summary = buildSummaryFromWizardData(
        templateData,
        language,
        riskyPositions
    );
    const editLabel = language.getValue(
        "missionTemplate.confirmation.edit",
        "Modifier"
    );

    return (
        <SectionWrapper
            title={language.getValue(
                "missionTemplate.confirmation.title",
                "Tout est bon ?"
            )}
            description={language.getValue(
                "missionTemplate.confirmation.description",
                "Relisez la fiche avant de l'enregistrer. Vous pourrez la modifier plus tard."
            )}
        >
            <div className={"flex flex-col"}>
                {SUMMARY_ROWS.map((row) => {
                    const label = getSummaryRowLabel(language, row);
                    return (
                        <SummaryField
                            key={row.key}
                            label={label}
                            value={getSummaryRowValue(language, row, summary)}
                            editLabel={`${editLabel} : ${label}`}
                            editTooltip={editLabel}
                            onEdit={() =>
                                setTemplatePage(
                                    getTemplateStepPage(STEP_BY_FIELD[row.key])
                                )
                            }
                        />
                    );
                })}
            </div>
        </SectionWrapper>
    );
};

export default ConfirmationTemplate;
